import React, {Component} from 'react';
import {Box, Button, Tooltip, Typography} from "@material-ui/core";
import {withSnackbar} from "notistack";
import {ReactGrid} from "components/helpers/reactGrid/reactGrid";
import {MainContext} from "contexts/main.context";
import {ExportOptions} from "components/helpers/exportOptions/export.options";
import ListadosService from "services/listados.service";
import MomentUtils from "@date-io/moment";
import Switch from "@material-ui/core/Switch";
import {CloudUploadRounded, BlurOnRounded} from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import {sortNumeric} from "../../../assets/utils";

export class Excel extends Component {
    state = {
        columns: [
            {name: 'hoja', title: 'Hoja'}
        ],
        rows: [
            {hoja: "Shell LCC Plazo"},
            {hoja: "Shell LCC Clientes"},
            {hoja: "Shell LCC Esp"},
            {hoja: "Shell Completo"},
            {hoja: "PROMOS"},
            {hoja: "Tecfil"},
            {hoja: "Osram"},
            {hoja: "LISTAS MOTOS"},
            {hoja: "BOSCH FILTROS"},
            {hoja: "BOSCH ESCOBILLAS PLAZOS"},
            {hoja: "BOSCH ESCOBILLAS CLIENTES"},
            {hoja: "TRICO ESCOBILLAS CLIENTES"},
            {hoja: "MAHLE"},
            {hoja: "WEGA"}
        ],
        selected: [],
        compare: false,
        fileComparation: null,
        all: false
    };

    ListadosService = new ListadosService(this.context);

    componentDidMount() {
        this.addPROVGENERALSheet();
    }

    addPROVGENERALSheet = () => {
        if (this.userCanViewPROVGENERALSheet()) {
            this.setState(prevState => {
                prevState.rows.push({
                    hoja: 'PROVGENERAL'
                });
            }, this.context.updateWindowDimensions);
        }
    }

    // Declaratividad
    userCanViewPROVGENERALSheet = () => {
        const authorizedRoles = ['A','O'];
        const actualRole = this.context.loggedUser.role;
        return authorizedRoles.includes(actualRole);
    }

    onChangeSwitchAll = () => this.setState(prevState => (prevState.all = !prevState.all));

    onSelect = selected => {
        this.setState({
            selected: selected
        });
    };

    getExcel = fnSuccess => {
        let hojas = this.state.selected;

        var formData = new FormData();

        // Paso los parámetros a un formData para poder enviar el archivo (lista de precios)
        if (this.state.compare)
            formData.append('lista_vieja', this.state.fileComparation);

        formData.append('hojas', JSON.stringify(hojas));

        this.ListadosService.listaPreciosExcel(
            formData,
            file => fnSuccess(file),
            error => this.props.enqueueSnackbar(error, {variant: 'error'})
        )
    };

    // Descarga las hojas seleccionadas en PDF. Si hay una sola hoja el backend devuelve el PDF; si hay
    // varias, un ZIP con un PDF por cada hoja (ver getPDFFileName).
    getPDF = fnSuccess => {
        this.ListadosService.listaPreciosHojasPDF(
            this.state.selected,
            file => fnSuccess(file),
            error => this.props.enqueueSnackbar(error, {variant: 'error'})
        );
    };

    // lista_precios_{hoja}_{YYYYMMDDHHMMSS}.{extension}: el nombre de la hoja va solo si hay una seleccionada.
    // Se calcula al momento de exportar.
    getFileName = extension => {
        const hojas = this.state.selected;
        const hoja = hojas.length === 1 ? `${hojas[0]}_` : '';
        return `lista_precios_${hoja}${(new MomentUtils()).date().format('YYYYMMDDHHmmss')}.${extension}`;
    };

    getExcelFileName = () => this.getFileName('xlsx');

    // Con varias hojas el backend devuelve un ZIP con un PDF por hoja.
    getPDFFileName = () => this.getFileName(this.state.selected.length > 1 ? 'zip' : 'pdf');

    // El mail y el Excel dependen de la lista anterior cuando se comparan precios; el PDF no.
    validateExport = action => {
        const {all, selected, compare, fileComparation} = this.state;

        if (all === false && selected.length < 1)
            return 'Debe seleccionar al menos una hoja';
        if (['mail', 'excel'].includes(action) && compare && fileComparation === null)
            return 'Debe subir la lista anterior para poder hacer la comparación de precios';

        return null;
    };

    toggleCompare = () => this.setState({compare: !this.state.compare});

    onUploadLista = event => {
        if (event.target.files.length <= 0) {
            this.props.enqueueSnackbar('Debe seleccionar un archivo para subir', {variant: "error"});
            return false;
        }

        var ext = event.target.files[0].name.match(/\.([^\.]+)$/)[1];
        if (ext !== 'xlsx') {
            this.props.enqueueSnackbar('Debe subir un archivo con extensión .xlsx', {variant: "error"});
            return false;
        }

        this.setState({fileComparation: event.target.files[0]});
    }

    render() {
        const {columns, rows, selected, compare} = this.state;
        return (
            <React.Fragment>
                {(this.context.loggedUser.role === "A" || this.context.loggedUser.role === "O") && (
                    <Grid container className={"m-2"}>
                        <Box>
                            <Switch
                                checked={compare}
                                onChange={this.toggleCompare}
                                name="checkedA"
                                inputProps={{'aria-label': 'secondary checkbox'}}
                            />
                            <Typography variant={"body2"} component={"span"}>Comparar precios</Typography>
                        </Box>
                        {compare && (
                            <Box className={"ml-5"}>
                                <input accept=".xlsx" className={'d-none'} name="plantilla-file" id="plantilla-file" type="file" onChange={this.onUploadLista}/>
                                <label htmlFor="plantilla-file">
                                    <Tooltip title={'Subir lista anterior'}>
                                        <Button
                                            variant={"contained"}
                                            size={"small"}
                                            startIcon={<CloudUploadRounded/>}
                                            component={"span"}
                                        >
                                            Subir lista anterior
                                        </Button>
                                    </Tooltip>
                                </label>
                            </Box>
                        )}
                    </Grid>
                )}
                <ReactGrid
                    title={'Hojas a Descargar'}
                    columns={columns}
                    rows={rows}
                    height={-300}
                    enableFiltering={false}
                    onDelete={selected => this.onSelect([])}
                    selectedRows={selected}
                    onSelectionChange={this.onSelect}
                    enableSelection={true}
                    showSelectAll={true}
                    enableSorting={true}
                    getRowId={row => row.hoja}
                    // showSwitchAll={true}
                    // switchAllValue={all}
                    // onChangeSwitchAll={() => this.onChangeSwitchAll()}
                />
                <ExportOptions
                    enableMail
                    enableDownload
                    enableExcel
                    fabIcon={<BlurOnRounded/>}
                    getPDF={this.getPDF}
                    getExcel={this.getExcel}
                    fileName={this.getPDFFileName}
                    excelFileName={this.getExcelFileName}
                    mailAttachment={'excel'}
                    mailSubject={`Lista Precio`}
                    mailBody={"Estimado,  \n\nSe adjunta la lista de precios."}
                    validate={this.validateExport}
                />
            </React.Fragment>
        )
    }
}

Excel.contextType = MainContext;
Excel = withSnackbar(Excel);
